type Listener = () => void;

const listeners = new Set<Listener>();

/** Refresh the in-app notification bell after an invite or alert is written. */
export function notifyNotificationsChanged(): void {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      // ignore listener errors
    }
  });
}

export function subscribeNotificationsChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
